import { ConvertedAddressFormatType } from './AddressVerifySelect.component';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { Fragment, useCallback } from 'react';
import { Box, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type AddressVerifyCellType = {
  address: ConvertedAddressFormatType;
  compareToAddress?: ConvertedAddressFormatType;
};

const useStyles = makeStyles()(theme => ({
  highlight: {
    color: theme.palette.secondary.main,
    fontWeight: 600
  }
}));

export const AddressVerifyCell: React.VFC<AddressVerifyCellType> = ({ address, compareToAddress }) => {
  const { classes } = useStyles();

  const highlightDeficits = useCallback(<T extends keyof ConvertedAddressFormatType>(
    addressString: ConvertedAddressFormatType[T],
    compareToAddressString: ConvertedAddressFormatType[T],
  ) => {
    const matches = match(addressString, compareToAddressString);
    const parts = parse(addressString, matches);

    return parts.map(({ highlight, text }, i) => (
      <Fragment key={i}>
        {/* Invert match highlight to highlight non-matches */}
        {!highlight ? <span className={classes.highlight}>{text}</span> : text}
      </Fragment>
    ));
  }, [ classes.highlight ]);

  return (
    <Box ml={1}>
      {Array<keyof ConvertedAddressFormatType>('address1', 'address2', 'addressCityState').map((key, i) => (
        <Typography key={i}>
          {!compareToAddress ? address[key] : highlightDeficits(address[key], compareToAddress[key])}
        </Typography>
      ))}
    </Box>
  );
};